import { Box, Text, theme } from '@/components';
import { type FC, type ReactNode, isValidElement } from 'react';

type Props = {
  children: ReactNode;
  paddingTop?: number;
  borderBottom?: string | number;
  title?: string | ReactNode;
};
export const ContentWrapper: FC<Props> = ({
  children,
  paddingTop,
  borderBottom,
  title,
}) => {
  const { token } = theme.useToken();
  return (
    <Box
      width="100%"
      padding={`${paddingTop ?? '32'}px 24px 32px 24px`}
      borderBottom={borderBottom ?? `2px solid ${token.colorBorder}`}
    >
      {title ? (
        isValidElement(title) ? (
          <>{title}</>
        ) : (
          <Text variant="h3" text={title as string | number} />
        )
      ) : null}
      {children}
    </Box>
  );
};
